import { Injectable } from "@angular/core";
import { LoadingController } from "ionic-angular";
import { ToastProvider } from "../toast/toast";
import { AngularFireDatabase } from "angularfire2/database";
import { AngularFireAuth } from "angularfire2/auth";
import "rxjs/add/operator/switchMap";
import "rxjs/add/operator/do";

/*
  Generated class for the PaymentServiceProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class PaymentServiceProvider {
  userId: string;
  membership: any;
  user: any;
  constructor(
    public loadingCtrl: LoadingController,
    public toast: ToastProvider,
    private db: AngularFireDatabase,
    private afAuth: AngularFireAuth,
  ) {
    this.membership = this.afAuth.authState
      .do(user => {
        this.userId = user.uid;
        this.user = user;
        return this.db.object(`users/${this.user.uid}/pro-membership`);
      })
      // .switchMap(user => {
      //   return this.db.object(`users/${user.uid}/pro-membership`);
      // });
  }

  processPayment(token: any) {
    return this.db
      .object(`/users/${this.userId}/pro-membership`)
      .update({ token: token.id });
  }
}



// WEBPACK FOOTER //
// ./src/providers/payment-service/payment-service.ts